const oesa = {
  prepage: {
    leistungen: [
      'Absicherung von Mobiliarverglasungen',
      'Bruchschäden an Gebäudeverglasungen',
      'Mehr- und Folgekosten (z.B. Notverglasung)',
    ],
  },
  produktvergleich: {
    produkte: {
      glasbruch: `<h4>Glasbruchschäden</h4>
        <p>Unsere Glasversicherung springt ein, wenn nach einem Bruchschaden die versicherte Innen- und/oder 
        Außenverglasung ersetzt werden muss. Wir erstatten die Kosten für den Ersatz der versicherten Verglasung 
        in gleicher Art und Güte – und zwar unabhängig von der Schadenursache.</p>
        <p>Die Absicherung von privat genutzten Kleingewächshäusern (auf dem Wohngrundstück bis 3.000 €), kann durch 
        individuelle Vereinbarung mitversichert werden. Wenden Sie sich hierfür an Ihren Fachbereich Versicherung.</p>`,
      folgekosten: `<h4>Mehr- und Folgekosten</h4>
        <p>Wir übernehmen Mehrkosten durch behördliche Vorschriften wie zum Beispiel eine neue Energieeinsparverordnung. 
        Auch Einbau und Entsorgung der beschädigten Verglasung sind natürlich inklusive. Sollte kurzfristig eine 
        Notverglasung erforderlich sein, übernehmen wir auch diese Kosten.</p>
        <p>Außerdem sind bis 1.000 € je Schadenfall mitversichert: Sonderkosten für Gerüste, Kräne oder Ähnliches; 
        Beseitigung und Wiederanbringen von Hindernissen wie Markisen oder Schutzgittern; Erneuerung von Anstrichen, 
        Malereien, Schriften, Verzierungen, Folien; Schäden an Umrahmungen, Mauerwerk, Schutzeinrichtungen.</p>
        <p>Eine höhere Entschädigungsgrenze kann durch individuelle Vereinbarung mitversichert werden. Wenden Sie sich 
        hierfür an Ihren Fachbereich Versicherung.</p>`,
      mobiliar: `<h4>Mobiliarverglasung</h4>
        <p>Versichert sind Mobiliarverglasungen von Bildern, Schränken, Vitrinen; Stand-, Wand- und Schrankspiegeln; 
        Glasplatten; Glasscheiben und Sichtfenster von Öfen, Elektro- und Gasgeräten; Aquarien/Terrarien, Platten aus 
        Glaskeramik und Glaskeramik-Kochflächen.</p>
        <p>Außerdem sind bis jeweils 1.000 € je Schadenfall mitversichert: künstlerisch bearbeitete Glasscheiben, 
        -spiegel und -platten.</p>
        <p>Eine höhere Entschädigungsgrenze kann durch individuelle Vereinbarung mitversichert werden. Wenden Sie sich 
        hierfür an Ihren Fachbereich Versicherung.</p>`,
      gebaeude: `<h4>Gebäudeverglasung<h4>
        <p>Versichert sind Gebäudeverglasungen von Fenstern, Türen, Balkonen, Terrassen, Wänden, Wintergärten, Veranden, 
        Loggien, Wetterschutzvorbauten, Dächern, Brüstungen, Duschkabinen, Lichtkuppeln, Sonnenkollektoren einschließlich 
        Rahmen, Glasbausteinen und Profilbaugläsern.</p>
        <p>Außerdem sind bis jeweils 1.000 € je Schadenfall mitversichert: künstlerisch bearbeitete Glasscheiben, 
        -spiegel und -platten.</p>
        <p>Eine höhere Entschädigungsgrenze sowie die Gebäudeverglasung der Einliegerwohnung kann durch individuelle 
        Vereinbarung mitversichert werden. Wenden Sie sich hierfür an Ihren Fachbereich Versicherung.</p>`,
    },
  },
};

export default oesa;
